import React from 'react'
import { string, object } from 'prop-types'
const defaultTranslationConfig = require(`../../../config/components/productList/uk/`)

// This are used to populate the caveat at the bottom of the table
let startDate
let endDate
let dateUsed

class hotelParkingTable extends React.Component {
  getTranslationConfig () {
    const { domainSettings: { language = 'UK' } } = this.props
    if (language !== 'UK') {
      const translationConfig = require(`../../../config/components/productList/${language.toLowerCase()}/`)
      return translationConfig
    }
    return defaultTranslationConfig
  }

  getType (productClass) {
    if (productClass === 'HCP' || productClass === 'HO') return 'hotelLocations'
    if (productClass === 'LO') return 'loungesLocations'
    return 'parkingLocations'
  }

  getTableDataFromFeed (translationConfig) {
    const { location, pageData: { productClass }, terminal, setVar = { }, domainSettings: { contentStaticServer }, settings: { decimalNotation, priceFormat } } = this.props
    const allowedColumns = {
      'HO': {
        title: true,
        perDayPrice: true,
        perWeekPrice: true,
        starRating: true,
        distance: true,
        transfers: true
      },
      'HCP': {
        title: true,
        perDayPrice: true,
        perWeekPrice: true,
        starRating: true,
        distance: true,
        transfers: true
      },
      'LO': {
        title: true,
        times: true,
        rating: true,
        lowestPrice: true,
        logo: true
      },
      'CP': {
        title: true,
        perDayPrice: true,
        perWeekPrice: true,
        distance: true,
        transfers: true,
        rating: true
      }
    }
    try {
      const type = this.getType(productClass.toUpperCase())
      let tableData = require('../../../../config/exports/buildTimeOnly/' + type + '/' + location.code + (terminal.length > 0 ? '_' + terminal : '') + '.json')
      tableData = this.makeTableObject(tableData, contentStaticServer, type, translationConfig, decimalNotation)
      return this.makeTableRow(tableData, setVar, allowedColumns, productClass, translationConfig, priceFormat)
    } catch (e) {
      return false
    }
  }

  getTableHeaders (translationConfig) {
    const { pageData } = this.props
    const { roomOnlyPriceText, includingOneWeekParkingText, carParkText, starsText, distanceText, transfersText, loungeText, timesText, ratingText, priceText, pricePerDayText, pricePerWeekText } = translationConfig
    const type = pageData.productClass.toUpperCase()
    if (type === 'HCP' || type === 'HO') {
      return (
        <tr>
          <th data-sort='string'>Hotel</th>
          <th data-sort='float'>{roomOnlyPriceText}</th>
          <th data-sort='float'>{includingOneWeekParkingText}</th>
          <th className='hidden-xs' data-sort='int'>{starsText}</th>
          <th className='hidden-xs' data-sort='float'>{distanceText}</th>
          <th className='hidden-xs'>{transfersText}</th>
        </tr>
      )
    }
    if (type === 'LO') {
      return (
        <tr>
          <th data-sort='string' style={{ minWidth: '90px' }}>{loungeText}</th>
          <th className='hidden-xs' data-sort='float' />
          <th data-sort='float' style={{ minWidth: '82px' }}>{timesText}</th>
          <th className='rating' data-sort='float' style={{ minWidth: '82px' }}>{ratingText}</th>
          <th data-sort='int'>{priceText}</th>
        </tr>
      )
    }
    return (
      <tr>
        <th data-sort='string'>{carParkText}</th>
        <th data-sort='float'>{pricePerDayText}</th>
        <th data-sort='float'>{pricePerWeekText}</th>
        <th className='hidden-xs' data-sort='float' style={{ minWidth: '80px' }}>{distanceText}</th>
        <th className='hidden-xs'>{transfersText}</th>
        <th className='hidden-xs rating' data-sort='int'>{ratingText}</th>
      </tr>
    )
  }

  // Create each table row object how we need it
  makeTableObject (tableData, contentStaticServer, type, translationConfig, decimalNotation = '.') {
    const output = [ ]
    Object.keys(tableData).map(key => {
      const item = tableData[key]
      if (!item.prodlib) return
      let {
        tripappcarparkname,
        tripapphotelname,
        tripappaddonname,
        name,
        on_airport: onAirport,
        address,
        transfer_time: transferTime,
        transfer_minutes: transferMinutes,
        transfers_included_in_price: transfersIncludedInPrice,
        free_transfers: freeTransfers,
        transfer_price: transferPrice,
        distance_miles: distanceMiles,
        meet_and_greet: meetAndGreet,
        wistia_key: wistiaKey,
        openingtime: openingTime,
        closingtime: closingTime,
        _prodcode,
        logo,
        exclude_from_seo_table: tableExclude,
        parkplatzname,
        adresse
      } = item.prodlib
      const { domainSettings } = this.props

      if (tableExclude) return

      const productName = parkplatzname || tripappcarparkname || tripapphotelname || tripappaddonname || item.title || name
      let pageName = item.pagename && item.pagename.replace('"', '')
      if (['www.holidayextras.com', 'staging.holidayextras.com'].indexOf(domainSettings.domain) !== -1) {
        pageName = '/' + (domainSettings.countryCode || domainSettings.language) + pageName
      }
      onAirport = parseInt(onAirport, 10)

      const { notRequiredText, includedText, minutesShortText, milesText, onAirportText } = translationConfig
      const zeroMiles = '0.0'.replace('.', decimalNotation)
      const zeroPrice = '0.00'.replace('.', decimalNotation)

      transferTime = transferMinutes || transferTime
      let transferText = notRequiredText
      if (transferTime && transferTime !== 'O') {
        transferText = `${transferTime} ${minutesShortText}`
      } else if (transfersIncludedInPrice || freeTransfers || (transferPrice && (/FREE/gi).test(transferPrice))) {
        transferText = includedText
      }

      const distanceUnits = parseFloat(distanceMiles).toFixed(1).replace('.', decimalNotation)
      let distanceText = `${distanceUnits} ${milesText}`
      if (!distanceMiles) distanceText = `${zeroMiles} ${milesText}`
      if (parseInt(meetAndGreet, 10)) {
        distanceText = onAirportText
      } else if (onAirport) {
        distanceText = onAirportText
      }

      let perDayPrice, perWeekPrice, lowestPrice
      if (item.price) {
        startDate = item.price.startDate ? item.price.startDate : startDate
        endDate = item.price.endDate ? item.price.endDate : endDate
        dateUsed = item.price.dateUsed ? item.price.dateUsed : dateUsed
        lowestPrice = item.price.lowestPrice
        perDayPrice = item.price.per_day || item.price.lowestDays0
        perWeekPrice = item.price.per_week || item.price.lowestDays8
      }
      let perDayUnits = perDayPrice || zeroPrice
      let perWeekUnits = perWeekPrice || zeroPrice
      if (lowestPrice) lowestPrice = parseFloat(lowestPrice).toFixed(2).replace('.', decimalNotation)
      if (perDayPrice) perDayPrice = parseFloat(perDayPrice).toFixed(2).replace('.', decimalNotation)
      if (perWeekPrice) perWeekPrice = parseFloat(perWeekPrice).toFixed(2).replace('.', decimalNotation)

      let starRatingOutput = ''
      for (let i = 0; i < item.prodlib.star_rating; i++) {
        starRatingOutput += '★'
      }

      if (logo && contentStaticServer) {
        logo = logo.replace('/imageLibrary/Images', contentStaticServer + '/libraryimages/Images')
      }

      output.push({
        productName,
        _prodcode,
        pageName,
        linkTitle: item.title || name,
        address: adresse || (address && address.replace(/(<br \/>|<br>|<br\/>)/g, ' ')),
        extraLinks: item.links,
        score: type === 'hotelLocations' ? false : item.score,
        starRating: item.prodlib.star_rating,
        starRatingOutput,
        wistiaKey,
        transferText,
        distanceUnits,
        distanceText,
        openingTime,
        closingTime,
        perDayPrice,
        perWeekPrice,
        perDayUnits,
        perWeekUnits,
        lowestPrice,
        logo,
        type
      })
      return item
    })
    return output
  }

  makeTableRow (tableRows = [ ], setVar, allowedColumns, type, translationConfig, priceFormat = '£') {
    const { mapAndDirectionsText, photosText, videoText, customerReviewsText, reviewsText, thisIsAGuidePriceOnlyText, bookAgainText, loungeOpenTimesText, loungeOpenTimesShortText } = translationConfig
    const { domainSettings } = this.props
    const urlPrefix = domainSettings.domain === 'www.holidayextras.com' ? '/' + domainSettings.language : ''
    return tableRows.map((tableRow, key) => {
      if (!tableRow.productName) return null
      const bookAgainReplacementObject = {
        'AVERAGEASPERCENTAGE': tableRow.score && tableRow.score.averageAsPercentage,
        'COUNT': tableRow.score && tableRow.score.count
      }
      const loungeReplacementObject = {
        'OPENINGTIME': tableRow.openingTime,
        'CLOSINGTIME': tableRow.closingTime
      }
      const bookAgainTextReplaced = this.multiStringReplace(bookAgainReplacementObject, bookAgainText)
      return (
        <tr key={key} data-productcode={tableRow._prodcode}>
          <td className='productTitle'>
            { tableRow.pageName && allowedColumns[type].title ? (
              <a href={tableRow.pageName} className='hotelname show bold' title={tableRow.linkTitle}>{ tableRow.productName }</a>
            ) : tableRow.productName }
            { tableRow.address && !(/(mystery|undercover)/gi).test(tableRow.productName) && (
              <small className='prodAddress hidden-xs'>{ tableRow.address }</small>
            )}
            <br />
            { tableRow.extraLinks && tableRow.extraLinks.directions && (
              <a className='table-link directionsLink' href={urlPrefix + '/' + tableRow.extraLinks.directions + '.html'} title={mapAndDirectionsText}>{mapAndDirectionsText}</a>
            )}
            { tableRow.extraLinks && tableRow.extraLinks.photos && (
              <a className='table-link photosLink' href={urlPrefix + '/' + tableRow.extraLinks.photos + '.html'} title={photosText}>{photosText}</a>
            )}
            { tableRow.wistiaKey && (
              <a href='#' data-newwindow={'https://fast.wistia.net/embed/iframe/' + tableRow.wistiaKey + '?autoPlay=true&controlsVisibleOnLoad=true&playButton=false&playerColor=F36F36&popover=true&version=v1&videoHeight=180&videoWidth=320'} className='table-link wistia-popover[height=180,playerColor=7b796a,width=320]'>{videoText}</a>
            )}
            { tableRow.extraLinks && tableRow.extraLinks.reviews && (
              <a className='table-link' href={urlPrefix + '/' + tableRow.extraLinks.reviews + '.html'} title={customerReviewsText}>{reviewsText}</a>
            )}
          </td>
          { allowedColumns[type].logo && (
            <td data-sort-value={tableRow.logo} className='center hidden-xs'>
              <img src={tableRow.logo} title={tableRow.title} width='100%' />
            </td>
          )}
          { allowedColumns[type].perDayPrice && (
            <td data-sort-value={tableRow.perDayUnits} className='bold purple purplePrice tableTooltip' title={thisIsAGuidePriceOnlyText}>
              {tableRow.perDayPrice && !setVar.hideTablePrices && `${priceFormat}${tableRow.perDayPrice}*`}
            </td>
          )}
          { allowedColumns[type].perWeekPrice && (
            <td data-sort-value={tableRow.perWeekUnits} className='bold purple purplePrice tableTooltip' title={thisIsAGuidePriceOnlyText}>
              {tableRow.perWeekPrice && !setVar.hideTablePrices && `${priceFormat}${tableRow.perWeekPrice}*`}
            </td>
          )}
          { allowedColumns[type].starRating && (
            <td className='hidden-xs bold stars' data-sort-value={tableRow.starRating}>
              { tableRow.starRating && tableRow.starRatingOutput }
            </td>
          )}
          { allowedColumns[type].distance && (
            <td data-sort-value={tableRow.distanceUnits} className='center miles hidden-xs'>
              { tableRow.distanceText }
            </td>
          )}
          { allowedColumns[type].transfers && (
            <td className='hidden-xs'>
              { tableRow.transferText }
            </td>
          )}
          { allowedColumns[type].times && (
            <td>
              { tableRow.openingTime && tableRow.closingTime ? (
                <span className='reviewPercent tableTooltip small' data-placement='top' title={this.multiStringReplace(loungeReplacementObject, loungeOpenTimesText)} dangerouslySetInnerHTML={{ __html: this.multiStringReplace(loungeReplacementObject, loungeOpenTimesShortText) }} />
              ) : (null)}
            </td>
          )}
          { allowedColumns[type].rating && (
            <td className='hidden-xs rating lo'>
              { tableRow.score && tableRow.score.averageAsPercentage ? (
                <span className='reviewPercent tableTooltip' data-toggle='tooltip' data-placement='top' title={bookAgainTextReplaced} rel={tableRow.score.count}>{ tableRow.score.averageAsPercentage }%</span>
              ) : (null)}
            </td>
          )}
          { allowedColumns[type].lowestPrice && (
            <td data-sort-value={tableRow.lowestPrice}>
              { tableRow.lowestPrice && !setVar.hideTablePrices && (
                <strong className='bold purple purplePrice tableTooltip' data-toggle='tooltip' data-placement='top' title={thisIsAGuidePriceOnlyText}>&pound;{ tableRow.lowestPrice }*</strong>
              )}
            </td>
          )}
        </tr>
      )
    })
  }

  multiStringReplace (replaceObj, textToReplace) {
    const regex = new RegExp(Object.keys(replaceObj).join('|'), 'gi')
    return textToReplace.replace(regex, (matched) => {
      return replaceObj[matched]
    })
  }

  createCaveat (translationConfig) {
    const { pageData } = this.props
    const { carParkingCaveat, otherCaveat, thisIsAGuidePriceOnlyText } = translationConfig
    const caveatReplaceObj = {
      'STARTDATE': startDate,
      'ENDDATE': endDate,
      'DATEUSED': dateUsed
    }

    if (typeof dateUsed === 'undefined' || typeof startDate === 'undefined') return `*${thisIsAGuidePriceOnlyText}`
    let caveat = otherCaveat
    if (pageData.productClass.toUpperCase() === 'CP' && typeof endDate !== 'undefined') caveat = carParkingCaveat

    return this.multiStringReplace(caveatReplaceObj, caveat)
  }

  render () {
    const { id, domainSettings: { language = 'UK' } } = this.props
    const translationConfig = this.getTranslationConfig()
    const tableContents = this.getTableDataFromFeed(translationConfig)

    if (!tableContents.length) {
      return (
        <span id={id} />
      )
    }
    const tableHeaders = this.getTableHeaders(translationConfig)
    const tableContainerClass = language === 'it' ? '' : 'row'
    return (
      <div id={id} className={tableContainerClass}>
        <table className='table table-condensed table-striped product-table-slim hxTableSort'>
          <thead>
            { tableHeaders }
          </thead>
          <tbody>
            { tableContents }
          </tbody>
        </table>
        <p>{this.createCaveat(translationConfig)}</p>
      </div>
    )
  }
}

hotelParkingTable.propTypes = {
  id: string.isRequired,
  terminal: string,
  pageData: object,
  location: object,
  settings: object,
  setVar: object,
  domainSettings: object
}

hotelParkingTable.defaultProps = {
  terminal: ''
}

export default hotelParkingTable



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/productTable.jsx